import { Forms } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import { routes } from '~/components/app/appMainRoutes';
import { useEntitlements } from '~/hooks/account';

import { HomeNextStep } from '../HomeNextStep';

export const StepSetupForms = () => {
  const { hasAccessFormsHubspot } = useEntitlements();

  const formsRoute = hasAccessFormsHubspot
    ? routes.formsHubspot
    : '/integrations/forms';

  return (
    <HomeNextStep>
      <HomeNextStep.Heading>
        Increase your form conversion rates with form enrichment & dynamic form
        shortening
      </HomeNextStep.Heading>
      <HomeNextStep.Description>
        Now that you have Clearbit JS installed, you can shorten forms on your
        website{' '}
      </HomeNextStep.Description>
      <HomeNextStep.Footer>
        <CKButton
          as={Link}
          leftIcon={<Forms />}
          to={formsRoute}
          variant="simple"
          variantColor="blue"
        >
          Set up Clearbit Forms
        </CKButton>
      </HomeNextStep.Footer>
    </HomeNextStep>
  );
};
